module.exports = __webpack_public_path__ + "img/yi2.4173006e.jpg";